import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DeclarationFormCardProps } from 'views/declarations/common/declaration.form.card';
import NewFormCard, { FormCardContainer } from '../../../common/cards/NewFormCard';
import PlaceOfLoadingAirportCodeBlock, {
    placeOfLoadingAirportCodeBlockValidation,
} from '../blocks/PlaceOfLoadingAirportCodeBlock';

export const placeOfLoadingAirportCodeCardValidation = {
    selfValidators: [placeOfLoadingAirportCodeBlockValidation],
};

const PlaceOfLoadingAirportCodeCard: FC<DeclarationFormCardProps> = (props) => {
    const { t } = useTranslation('form');

    return (
        <NewFormCard title={t('placeOfLoadingAirportCode')} hidden={props.hidden}>
            <FormCardContainer>
                <PlaceOfLoadingAirportCodeBlock />
            </FormCardContainer>
        </NewFormCard>
    );
};
export default PlaceOfLoadingAirportCodeCard;
